import { graphql } from "../generated";

// We have to fetch callId even if we don't use it, because `callId` is a keyField of CallConversation
export const SearchConversationContent = graphql(
  `
    query SearchConversationContent(
      $callIds: [Float]
      $transcriptionScope: TranscriptionScopeFilter
    ) {
      getCallConversations(
        callIds: $callIds
        transcriptionScope: $transcriptionScope
      ) {
        items {
          callId
          ...TranscriptionScopeDetail
        }
      }
    }
  `
);
